import React from 'react';
import { Box, Container, Typography, Button, Grid, Stack } from '@mui/material';
import { motion } from 'framer-motion';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import BusinessCenterRoundedIcon from '@mui/icons-material/BusinessCenterRounded';
import GroupsRoundedIcon from '@mui/icons-material/GroupsRounded';
import FamilyRestroomRoundedIcon from '@mui/icons-material/FamilyRestroomRounded';

const COVERAGE = [
  { icon: <BusinessCenterRoundedIcon sx={{ fontSize: 20 }} />, label: 'Sócios' },
  { icon: <GroupsRoundedIcon sx={{ fontSize: 20 }} />, label: 'Colaboradores' },
  { icon: <FamilyRestroomRoundedIcon sx={{ fontSize: 20 }} />, label: 'Família' },
];

const ParaClinicasSection: React.FC = () => {
  return (
    <Box
      id="clinicas"
      component="section"
      sx={{ py: { xs: 8, md: 12 }, bgcolor: 'background.default', scrollMarginTop: { xs: 88, md: 100 } }}
    >
      <Container maxWidth="lg">
        <Box
          component={motion.div}
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6 }}
          sx={{
            position: 'relative',
            overflow: 'hidden',
            borderRadius: '24px',
            bgcolor: 'primary.dark',
            color: '#fff',
            px: { xs: 4, md: 8 },
            py: { xs: 6, md: 8 },
            '&::after': {
              content: '""',
              position: 'absolute',
              width: 420,
              height: 420,
              borderRadius: '50%',
              background: 'radial-gradient(circle, rgba(45, 212, 191, 0.22) 0%, transparent 70%)',
              bottom: -180,
              left: -140,
            },
          }}
        >
          <Grid container spacing={4} alignItems="center" sx={{ position: 'relative', zIndex: 1 }}>
            <Grid item xs={12} md={8}>
              <Typography variant="h2" sx={{ fontSize: { xs: '1.6rem', md: '2rem' }, mb: 2 }}>
                Sua clínica também pode oferecer melhores benefícios.
              </Typography>
              <Typography sx={{ color: 'rgba(255,255,255,0.8)', fontSize: '1rem', lineHeight: 1.7, mb: 3, maxWidth: 560 }}>
                Soluções para clínicas e empresas da área da saúde que desejam avaliar planos e
                benefícios para sócios e colaboradores.
              </Typography>
              <Stack direction="row" spacing={3} sx={{ mb: { xs: 4, md: 0 } }}>
                {COVERAGE.map((item) => (
                  <Stack key={item.label} direction="row" spacing={1} alignItems="center" sx={{ color: '#5EEAD4' }}>
                    {item.icon}
                    <Typography sx={{ fontSize: '0.85rem', fontWeight: 600, color: 'rgba(255,255,255,0.85)' }}>
                      {item.label}
                    </Typography>
                  </Stack>
                ))}
              </Stack>
            </Grid>
            <Grid item xs={12} md={4} sx={{ textAlign: { xs: 'left', md: 'right' } }}>
              <Button
                component="a"
                href="#cotacao"
                variant="contained"
                size="large"
                endIcon={<ArrowForwardRoundedIcon />}
                sx={{ bgcolor: 'secondary.main', color: '#0A2038', fontWeight: 700, '&:hover': { bgcolor: 'secondary.light' } }}
              >
                Falar com um Especialista
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </Box>
  );
};

export default ParaClinicasSection;
